import { FC, useMemo } from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { CountBuyAndSellChartProps } from '../../../../../../core/domain/overview/count-buy-and-sell';
import { ChartCard } from '../../components/chart-card/chart-card';
import { BarSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: CountBuyAndSellChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'buys', name: 'خرید', color: CHART_COLORS.green },
    { key: 'sells', name: 'فروش', color: CHART_COLORS.red },
];

export const CountBuyAndSell: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'buys', data: chartData?.buys },
                { key: 'sells', data: chartData?.sells },
            ]),
        [chartData],
    );

    return (
        <ChartCard
            title="تعداد خرید و فروش ها"
            subtitle="روند تعداد سفارش‌های خرید و فروش"
            icon={<SwapOutlined />}
            accent="blue"
            loading={chartLoading}
            empty={!data.length}
            stats={[
                { label: 'خرید', value: faNumber(sumOf(data, 'buys')), color: CHART_COLORS.green },
                { label: 'فروش', value: faNumber(sumOf(data, 'sells')), color: CHART_COLORS.red },
            ]}
        >
            <BarSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
